var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 3C8.78494 3 3 8.78494 3 16C3 23.2148 8.78494 29 16 29C23.2147 29 29 23.2148 29 16C29 8.78494 23.2148 3 16 3ZM22.5002 20.68L20.6802 22.4999L16 17.8198L11.32 22.4999L9.49991 20.68L14.1801 16L9.49991 11.3199L11.32 9.50018L16 14.18L20.6801 9.50018L22.5001 11.3199L17.82 16L22.5002 20.68Z","fill":"#E9E9F0"}));
}

Close.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Close;

Close.default = Close;
